import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule} from "@angular/forms";
import { InventoryComponent } from './inventory.component';
import { CreateComponent } from './create.component';
import { ViewComponent } from './view.component';
import { ScanviewComponent } from './scanview.component';
import { PrinterComponent } from './printer.component';
import { PoComponent } from './po.component';
import { OrderComponent } from './order.component';
import { TabletComponent } from './tablet.component';
import { InventoryService } from './inventory.service';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { TabscanComponent} from './tabscan.component';
import { SqFtPipe } from '../shared/pipes/sq-ft-pipe';
import { CostSqFtPipe } from '../shared/pipes/cost-sq-ft-pipe';
import { TaxPipe } from '../shared/pipes/tax-pipe';
import { SearchInventoryPipe } from './pipes/search-inventory-pipe';
import { SortInventoryPipe } from './pipes/sort-inventory-pipe';
import { SortColorsPipe } from './pipes/sort-colors-pipe';
import { PoItemsPipe } from './pipes/po-items-pipe';
import { PoAmountPipe } from './pipes/po-amount-pipe';
import { SawyerPipe } from './pipes/sawyer-pipe';
import { NosawsPipe } from './pipes/nosaws-pipe';
import { CutStartedPipe } from './pipes/cut-started-pipe';
import {DenyNonStaffService} from "../shared/services/deny-non-staff.service";
import { NgArrayPipesModule } from 'ngx-pipes';

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    NgArrayPipesModule,
    RouterModule.forChild([
      { path: 'inventory', component: InventoryComponent, canActivate: [AuthGuardService, DenyNonStaffService] },
      { path: 'tablet', component: TabletComponent, canActivate: [AuthGuardService, DenyNonStaffService] }
    ])
  ],
  providers: [
    InventoryService
  ],
  declarations: [
    InventoryComponent,
    CreateComponent,
    ViewComponent,
    ScanviewComponent,
    PrinterComponent,
    PoComponent,
    OrderComponent,
    TabletComponent,
    TabscanComponent,
    SqFtPipe,
    CostSqFtPipe,
    TaxPipe,
    PoAmountPipe,
    PoItemsPipe,
    SearchInventoryPipe,
    SortInventoryPipe,
    SortColorsPipe,
    SawyerPipe,
    NosawsPipe,
    CutStartedPipe
  ]
})
export class InventoryModule { }



// WEBPACK FOOTER //
// ./src/app/inventory/inventory.module.ts